import { render } from "./IncidentsIntroduction.vue?vue&type=template&id=00c9d4c4"
import script from "./IncidentsIntroduction.vue?vue&type=script&lang=js"
export * from "./IncidentsIntroduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__